import { customGet, customPost } from "../../api/customApi";
import entityType from "../../api/entityType";
import genericActionType from "../../api/genericActionType";
import { Actions } from "./companyConstants";
import { downloadFile } from "../../utils/downloadFile";

export const readAction = (companyKey) => async (dispatch) => {
  dispatch({ type: Actions.READ_COMPANY });
  const payload = await customGet(entityType.COMPANY, genericActionType.READ, {
    params: {
      companyKey: companyKey,
    },
  });
  dispatch({ type: Actions.READ_COMPANY_SUCCEEDED, payload });
};

export const updateAction = (values) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_COMPANY });
  const payload = await customPost(
    entityType.COMPANY,
    genericActionType.UPDATE,
    values,
  );
  dispatch({ type: Actions.UPDATE_COMPANY_SUCCEEDED, payload });
};

export const uploadContractAction =
  (file, companyKey) => async (dispatch) => {
    dispatch({ type: Actions.UPLOAD_CONTRACT });
    try {
      const request = await customPost(
        entityType.COMPANY,
        "UploadContract",
        file,
        {
          file: true,
          params: { companyKey: companyKey },
          shouldThrow: true,
        },
      );

      if (!request.ok) {
        const errorResponse = await request.json();
        dispatch({
          type: Actions.UPLOAD_CONTRACT_SUCCEEDED,
          payload: errorResponse,
        });
        return;
      }

      const payload = await request.json();
      dispatch({ type: Actions.UPLOAD_CONTRACT_SUCCEEDED, payload });
    } catch (e) {
      console.log(e);
      dispatch({
        type: Actions.UPLOAD_CONTRACT_SUCCEEDED,
        payload: {
          Operation: {
            Outcome: "Error",
            Message:
              "An error occurred while uploading the contract file. Please contact support.",
          },
        },
      });
    }
  };

export const downloadContractAction = (companyKey, fileName) => async () => {
  try {
    const response = await customGet("Company", "DownloadContract", {
      params: { companyKey, fileName },
      blob: true,
    });
    const blob = await response.blob();
    downloadFile(blob, fileName);
  } catch (error) {
    console.error("Failed to download contract:", error);
  }
};

export const clearOperationResultAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_OPERATION_RESULT });
};
